// @flow
import {BaseApi} from 'modules/api/base';

class CentrifugeApi extends BaseApi {
    constructor(slaveHost, password) {
        super();
        this.url = slaveHost || '';
        this.clusterAuth = password
            ? {
                  'X-CLUSTER-AUTH': password,
              }
            : {};
    }

    getConnectionData() {
        return this.get(this.url + '/api/v1/centrifugo/init', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }
}

export {CentrifugeApi};
